import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import { MuiGrid, MuiTypography } from '../material-ui';
import SmallCTA from './SmallCTA';
import { ColumSmallCTA } from './SmallCTA/SmallCTA';
import SquareCTA from './SquareCTA';
import { SquareTileCTAProps } from './SquareTileCTA.interface';
import useStyles from './SquareTileCTA.styles';

const options = {
  column: ColumSmallCTA,
  smallCTA: SmallCTA,
  squareCTA: SquareCTA,
};

const SquareTileCTA = ({
  title,
  titleTextColor,
  columns = 2,
  content = [],
  theme = Theme.light,
}: PropsWithChildren<SquareTileCTAProps>) => {
  const classes = useStyles({});

  const col: { [key: number]: 1 | 2 | 3 | 4 | 6 | 12 } = {
    1: 4,
    2: 4,
    3: 4,
    4: 3,
    6: 2,
    12: 1,
  };

  const rootClasses = clsx(classes.root, `${theme}-theme`);
  const titleClass = clsx(classes.title, titleTextColor && 'title-blue');

  return (
    <div data-testid="qa-square-tile-cta-component" className={rootClasses}>
      {title && (
        <MuiTypography variant="overline" data-testid="qa-square-tile" className={titleClass}>
          {title}
        </MuiTypography>
      )}
      <div className={classes.row}>
        <MuiGrid container spacing={5}>
          {content.map((item, id) => {
            const Variant = options[item.type];
            return (
              // eslint-disable-next-line react/no-array-index-key
              <MuiGrid item xs={12} md={col[columns]} key={id}>
                <Variant content={item.content as any} theme={theme} />
              </MuiGrid>
            );
          })}
        </MuiGrid>
      </div>
    </div>
  );
};

export default SquareTileCTA;
